import { valueOf } from "@/types/common";

export const STANDARD_INDUSTRY_LEVEL = {
  MAJOR: "MAJOR",
  MINOR: "MINOR",
  DETAIL: "DETAIL",
} as const;

export type TStandardIndustryLevel = valueOf<typeof STANDARD_INDUSTRY_LEVEL>;

export const STANDARD_INDUSTRY_LEVEL_LABEL: Record<TStandardIndustryLevel, string> = {
  [STANDARD_INDUSTRY_LEVEL.MAJOR]: "中分類",
  [STANDARD_INDUSTRY_LEVEL.MINOR]: "小分類",
  [STANDARD_INDUSTRY_LEVEL.DETAIL]: "細分類",
};

// Child level for a given level; DETAIL is the leaf (no children).
export const STANDARD_INDUSTRY_CHILD_LEVEL: Record<TStandardIndustryLevel, TStandardIndustryLevel | null> = {
  [STANDARD_INDUSTRY_LEVEL.MAJOR]: STANDARD_INDUSTRY_LEVEL.MINOR,
  [STANDARD_INDUSTRY_LEVEL.MINOR]: STANDARD_INDUSTRY_LEVEL.DETAIL,
  [STANDARD_INDUSTRY_LEVEL.DETAIL]: null,
};

export const STANDARD_INDUSTRY_GROUP_CODE_MAX_LENGTH = 3;

// Segment length of the `code` input per level (MAJOR = up to 3 digits, MINOR/DETAIL = exactly 1 digit).
export const STANDARD_INDUSTRY_CODE_LENGTH: Record<TStandardIndustryLevel, number> = {
  [STANDARD_INDUSTRY_LEVEL.MAJOR]: 3,
  [STANDARD_INDUSTRY_LEVEL.MINOR]: 1,
  [STANDARD_INDUSTRY_LEVEL.DETAIL]: 1,
};
